import { useEffect, useState, useRef } from "react";

export default function FourDigitCode({ setCompletedCode, setIncomplete }) {
	const [codeArray, setCodeArray] = useState(["", "", "", ""]);
	const inputRefs = useRef([]);

	useEffect(() => {
		let newCode = "";
		for (let i = 0; i < codeArray.length; i++) {
			newCode += codeArray[i] || "";
		}
		setCompletedCode(newCode);
	}, [codeArray, setCompletedCode]);

	useEffect(() => {
		setIncomplete(codeArray.includes(""));
	}, [codeArray, setIncomplete]);

	const handleChange = (e, index) => {
		const value = e.target.value.toUpperCase();

		if (value.length > 1 || (value && !/^[A-Z0-9]$/.test(value))) return;

		setCodeArray((prev) => {
			const newArray = [...prev];
			newArray[index] = value;
			return newArray;
		});

		if (value && index < inputRefs.current.length - 1) {
			inputRefs.current[index + 1].focus();
		}
	};

	const handleKeyDown = (e, index) => {
		if (e.key === "Backspace" && !codeArray[index] && index > 0) {
			inputRefs.current[index - 1].focus();
		}
	};

	return (
		<div className="flex gap-4 justify-center w-full">
			{codeArray.map((mapData, index) => (
				<div key={index}>
					<input
						ref={(el) => (inputRefs.current[index] = el)}
						type="text"
						inputMode="text"
						autoComplete="off"
						value={codeArray[index]}
						onChange={(e) => handleChange(e, index)}
						onKeyDown={(e) => handleKeyDown(e, index)}
						maxLength={1}
						className="border border-black rounded-md p-2 w-12 text-center "
					/>
				</div>
			))}
		</div>
	);
}
